export default "__VITE_ASSET__DHdc4fLY__"